import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import { get } from 'lodash';
import { cart } from './modules/cart';
import { delivery } from './modules/delivery';
import { products } from './modules/products';
import { fvForm } from './modules/fvForm';
import { bankNumber } from './modules/bankNumber';
import { contactPerson } from './modules/contactPerson';
import { steps } from './modules/steps';
import { additionalInfo } from './modules/additionalInfo';
import { customer } from './modules/customer';
import { registration } from './modules/registration';
import { confection } from './modules/confection';
import { virtualCard } from './modules/virtualCard';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

Vue.use(Vuex);

const configElement = document.getElementById('config');
const config = JSON.parse(configElement.innerHTML);

const vuexPersist = new VuexPersist({
  key: config.product,
  storage: window.localStorage,
  modules: ['additionalInfo', 'delivery', 'products', 'cart', 'confection', 'virtualCard'],
});

const shop = RepositoryFactory.get('order');
/**
 * VueX pattern
 * View -> Actions -> State -> View ...
 *
 * State -> VueComponent -> Action -> --Commit-- Mutations(change state) -> State
 *
 * Projects Vuex modules structure base on : https://vuex.vuejs.org/guide/structure.html
 */
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async loadOrderData({ dispatch }, orderId) {
      const { data } = await shop.getOrderData(orderId);
      if (!data || !data.state) {
        throw new Error('No order data found for id:', orderId);
      }
      const { state: orderData } = data;
      await dispatch('additionalInfo/hydrate', get(orderData, 'additionalInfo', {}));
      await dispatch('bankNumber/hydrate', get(orderData, 'bankNumber', {}));
      await dispatch('cart/hydrate', get(orderData, 'cart', {}));
      await dispatch('contactPerson/hydrate', get(orderData, 'contactPerson', {}));
      await dispatch('delivery/hydrate', get(orderData, 'delivery', {}));
      await dispatch('fvForm/hydrate', get(orderData, 'fvForm', {}));
      await dispatch('virtualCard/hydrate', get(orderData, 'virtualCard', {}));
    },
  },
  getters: {},
  helperMethods: {},
  modules: {
    steps,
    cart,
    delivery,
    products,
    fvForm,
    bankNumber,
    contactPerson,
    additionalInfo,
    customer,
    registration,
    confection,
    virtualCard,
  },
  plugins: [vuexPersist.plugin],
});
